module.exports = __webpack_public_path__ + "img/图标9.8f5af08a.png";